// StripeContainer.js
import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import AddCardForm from "./AddCardForm";

const stripePromise = loadStripe(process.env.REACT_APP_SRTIPE_PUBLISHABLE_KEY);

const StripeContainer = ({ onAddCard }) => {
  return (
    <Elements stripe={stripePromise}>
      <AddCardForm onAddCard={onAddCard} />
    </Elements>
  );
};

export default StripeContainer;
